export default "__VITE_ASSET__b80bc6bb__$_?nuxt_component=async&nuxt_component_name=SvgoPuzzle__"